<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '160px'">
          <el-form-item label="显示名称" prop="duration">
          <el-input v-model="dataForm.duration" placeholder="显示名称(1个  2个   3个)"></el-input>
      </el-form-item>
          <el-form-item label="商品价格" prop="price">
          <el-input v-model="dataForm.price" placeholder="商品价格"></el-input>
      </el-form-item>
          <el-form-item label="商品规格" prop="commoditySpecification">
          <el-input :disabled="dataForm.type==2" v-model="dataForm.commoditySpecification" placeholder="商品规格(金币为个  会员为天或月)"></el-input>
      </el-form-item>
          <el-form-item label="商品排序" prop="commodityToSort">
          <el-input v-model="dataForm.commodityToSort" placeholder="商品排序"></el-input>
      </el-form-item>
          <!-- <el-form-item label="商品类型(1:钻石  2:VIP)" prop="type">
          <el-input v-model="dataForm.type" placeholder="商品类型(1:钻石  2:VIP)"></el-input>
      </el-form-item> -->
      <el-form-item prop="type" label="商品类型" size="mini">
        <el-radio-group v-model="dataForm.type">
          <el-radio :label="1">钻石</el-radio>
          <el-radio :label="2">VIP</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商品图片" prop="imageUrl">
        <ImageUpload :limit="1"
          v-model="dataForm.imageUrl"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>

      <!-- 二维码图片上传 -->
      <el-form-item label="微信二维码图片" prop="weChatQrCode">
        <ImageUpload :limit="1"
          v-model="dataForm.weChatQrCode"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
        <div class="form-tip">建议上传正方形二维码图片</div>
      </el-form-item>

      <!-- 二维码名称 -->
      <el-form-item label="微信二维码名称" prop="weChatQrCodeName">
        <el-input
          v-model="dataForm.weChatQrCodeName"
          placeholder="请输入二维码名称,如:支付宝收款码"
          maxlength="100"
          show-word-limit
        />
        <div class="form-tip">用于标识二维码用途</div>
      </el-form-item>
      <el-form-item label="支付宝二维码图片" prop="aliPayQrCode">
        <ImageUpload :limit="1"
          v-model="dataForm.aliPayQrCode"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
        <div class="form-tip">建议上传正方形二维码图片</div>
      </el-form-item>

      <!-- 二维码名称 -->
      <el-form-item label="支付宝二维码名称" prop="aliPayQrCodeName">
        <el-input
          v-model="dataForm.aliPayQrCodeName"
          placeholder="请输入二维码名称,如:微信收款码"
          maxlength="100"
          show-word-limit
        />
        <div class="form-tip">用于标识二维码用途</div>
      </el-form-item>
          <!-- <el-form-item label="是否开启(1:是  2:否)" prop="status">
          <el-input v-model="dataForm.status" placeholder="是否开启(1:是  2:否)"></el-input>
      </el-form-item> -->
      <el-form-item prop="status" label="是否开启" size="mini">
        <el-radio-group v-model="dataForm.status">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="2">否</el-radio>
        </el-radio-group>
      </el-form-item>
      
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        duration: '',
        price: '',
        commoditySpecification: '',
        commodityToSort: '',
        type: '',
        status: '',
        time: '',
        imageUrl: '',
        weChatQrCode: '',           // 新增:二维码图片
        aliPayQrCode: '',           // 新增:二维码图片
        aliPayQrCodeName: '',           // 新增:二维码图片
        weChatQrCodeName: ''        // 新增:二维码名称
      }
    }
  },
  computed: {
    dataRule () {
      return {
        duration: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        commoditySpecification: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        commodityToSort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        type: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/commodity/commodity/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/commodity/commodity/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped>
.form-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
  margin-top: 4px;
}
</style>
